import { createIcon } from '@chakra-ui/icons';

export const MultipleChoiceSimple = createIcon({
  displayName: 'MultipleChoiceSimple',
  viewBox: '0 0 11 10',
  path: [
    <svg xmlns="http://www.w3.org/2000/svg" width="11" height="10" viewBox="0 0 11 10" fill="none">
      <path
        d="M1.75 2.5C2.44036 2.5 3 1.94036 3 1.25C3 0.559644 2.44036 0 1.75 0C1.05964 0 0.5 0.559644 0.5 1.25C0.5 1.94036 1.05964 2.5 1.75 2.5Z"
        fill="currentColor"
      />
      <path d="M10.5 0.625H4.25V1.875H10.5V0.625Z" fill="currentColor" />
      <path
        d="M1.75 6.25C2.44036 6.25 3 5.69036 3 5C3 4.30964 2.44036 3.75 1.75 3.75C1.05964 3.75 0.5 4.30964 0.5 5C0.5 5.69036 1.05964 6.25 1.75 6.25Z"
        fill="currentColor"
      />
      <path d="M10.5 4.375H4.25V5.625H10.5V4.375Z" fill="currentColor" />
      <path
        d="M1.75 10C2.44036 10 3 9.44036 3 8.75C3 8.05964 2.44036 7.5 1.75 7.5C1.05964 7.5 0.5 8.05964 0.5 8.75C0.5 9.44036 1.05964 10 1.75 10Z"
        fill="currentColor"
      />
      <path d="M10.5 8.125H4.25V9.375H10.5V8.125Z" fill="currentColor" />
    </svg>,
  ],
});
